import { getSessionToken, isBackendSession } from "./authApi";

export type AuthGate = "wait" | "admit" | "login";

export type AuthGateInput = {
  /** Published by login, SSO callback and restore. Absent for legacy SSO. */
  userSession: unknown;
  userSessionLoading: boolean;
  tenantLoading: boolean;
  /** Whether this tenant signs in through SSO (and the flag is on). */
  ssoTenant: boolean;
};

/** Legacy SSO never creates a `userSession`, so its stored token is all there is to check. */
const admitsOnStoredToken = (ssoTenant: boolean) =>
  ssoTenant && !isBackendSession() && !!getSessionToken();

/**
 * Whether this visitor may see the app shell: in iff a session was actually
 * established. Don't admit on a marker alone, or a failed restore stays in the
 * shell with no data.
 */
export const resolveAuthGate = ({
  userSession,
  userSessionLoading,
  tenantLoading,
  ssoTenant,
}: AuthGateInput): AuthGate => {
  if (admitsOnStoredToken(ssoTenant)) return "admit";
  if (userSessionLoading || tenantLoading) return "wait";
  return userSession ? "admit" : "login";
};
